import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getPlanPurchaseLog } from "../../../../api/sim";
import { getChipColor } from "../../../../constants/value";
import { PLAN_PURCHASE_OPERATIONS } from "../../../../utils/planPurchase";

const PlanPurchaseHistory = ({ operation }) => {
  const [history, setHistory] = useState([]);
  const { plan_purchase_id } = useParams();
  const config = PLAN_PURCHASE_OPERATIONS[operation];

  const [response, call, loading] = useAxios({
    ...__getPlanPurchaseLog(plan_purchase_id),
  });

  useEffect(() => {
    if (response && response.status) {
      setHistory(response.data);
    }
  }, [response]);

  useEffect(() => {
    call();
  }, []);

  return loading ? (
    <Title content="Please wait..." variant="subtitle2" gutterBottom />
  ) : (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          {config.title} Log
        </Typography>
      </Box>

      {response && history.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">MDN</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Plan ID</TableCell>
                    <TableCell align="left">Purchase ID</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">{history.data.iccid}</TableCell>
                    <TableCell align="left">
                      <Link
                        underline="none"
                        to={`${config.route}/batch/${history.data.batch_id}`}
                      >
                        {history.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={history.data.status}
                        size="small"
                        color={getChipColor(history.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">{history.data.plan_id}</TableCell>
                    <TableCell align="left">{history.data.purchase_id}</TableCell>
                    <TableCell align="left">
                      {history.data.last_updated &&
                        `${format(
                          new Date(history.data.last_updated),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ApiLogHistory data={history.history.data} />
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default PlanPurchaseHistory;
